export const findFirstFocusableElement = (
  element = document,
  skipId = null
) => {
  const idExclusion = skipId ? `:not(#${skipId}):not(#${skipId} *)` : '' // Exclude the element and all its descendants

  const focusableSelectors = [
    `a[href]${idExclusion}`, // Anchor tags with an href
    `button${idExclusion}`, // Buttons
    `input:not([disabled])${idExclusion}`, // Enabled input fields
    `textarea:not([disabled])${idExclusion}`, // Enabled textareas
    `select:not([disabled])${idExclusion}`, // Enabled select dropdowns
    `details${idExclusion}`, // Details element
    `[tabindex]:not([tabindex="-1"])${idExclusion}`, // Elements with tabindex except -1
  ]

  const firstFocusable = element.querySelector(focusableSelectors.join(','))

  if (firstFocusable?.tagName.toLowerCase() === 'form') {
    // Check for other focusable elements within the form
    const nestedFocusable = firstFocusable.querySelector(
      focusableSelectors.join(',')
    )

    // Return the nested focusable element if found, otherwise return the form
    return nestedFocusable || firstFocusable
  }

  return firstFocusable
}

export const handleInitialFocus = (globalObject = {}, refName) => {
  const initialFocusedElement = document.activeElement

  if (initialFocusedElement) {
    globalObject['initialFocusedElement'] = initialFocusedElement
  }

  setTimeout(() => {
    const ref = globalObject.$refs[refName]
    if (ref) {
      const focusableElement = findFirstFocusableElement(ref.$el)
      if (focusableElement) {
        Array.isArray(focusableElement)
          ? focusableElement[0].focus()
          : focusableElement.focus()
      }
    }
  }, 200)
}

export const focusOut = (initialFocusedElement = undefined) => {
  setTimeout(() => {
    if (initialFocusedElement) {
      initialFocusedElement.focus()
    }
  }, 200)
}

export const isKeyExist = (popupContext, key = '') => {
  const popupManagerData = popupContext.popupManagerData || []
  return popupManagerData.some((item) => item.hasOwnProperty(key))
}

export const handleHide = (globalObject, dynamicKey = '') => {
  const popupContext = globalObject['popupContext']

  if (dynamicKey) {
    globalObject.$refs[dynamicKey].hide()
    if (popupContext && popupContext.popupManagerData.length) {
      const index = popupContext.popupManagerData.findIndex(
        (item) => Object.keys(item)[0] === dynamicKey
      )

      if (index !== -1) {
        // Use splice to remove the element at the found index
        globalObject['popupContext'].popupManagerData.splice(index, 1)
      }
    }

    focusOut(globalObject['initialFocusedElement'])
  }
}

export const handleHidePopOver = (globalObject, dynamicKey = '') => {
  handleHide(globalObject, `popover-${dynamicKey}`)
}

export const handleStoreFocus = (
  globalObject = undefined,
  guid = '',
  refName = ''
) => {
  const popupContext = globalObject['popupContext']

  setTimeout(() => {
    const dynamicKey = `popover-${guid}`

    if (
      popupContext &&
      popupContext.popupManagerData &&
      !isKeyExist(popupContext, dynamicKey)
    ) {
      const callableObject = function () {
        handleHide(globalObject, dynamicKey)
      }

      callableObject.isNotPicker = true

      globalObject['popupContext'].popupManagerData.push({
        [dynamicKey]: callableObject,
      })
      if (refName) {
        handleInitialFocus(globalObject, refName)
      }
    }
  }, 200)
}
